<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-input-param`]" width="1em" height="1em" v-bind="$attrs"><path d="M10 1.5C14.6944 1.5 18.5 5.30558 18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.72282 18.5 2.18423 15.3407 1.58887 11.2285H8.5L8.25879 12.9824C8.17465 13.5957 8.13219 13.9026 8.2334 14.0586C8.32122 14.1939 8.46974 14.2778 8.63086 14.2852C8.81656 14.2933 9.05977 14.1022 9.5459 13.7197L13.4756 10.6289C13.7482 10.4144 13.8844 10.3068 13.9336 10.1768C13.9767 10.0629 13.9766 9.93712 13.9336 9.82324C13.8844 9.69322 13.7481 9.58547 13.4756 9.37109L9.5459 6.2793C9.05997 5.89699 8.81653 5.70577 8.63086 5.71387C8.46976 5.7212 8.32123 5.80616 8.2334 5.94141C8.13244 6.09749 8.17471 6.40474 8.25879 7.01758L8.5 8.77148H1.58887C2.18423 4.65926 5.72282 1.5 10 1.5Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillInputParam',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
